import ButtonLink from 'components/button/Button'
import CampaignParticipant from './CampaignParticipant'
import CampaignProgram from './CampaignProgram'
import { useNavigate } from 'react-router-dom'
import { useCampaign } from '../hooks/useCampaignCreation'
import { useFormik } from 'formik'
import { regexAlpha } from 'constants/regex'
import { useEffect } from 'react'
import ModalCampaign from './ModalConfirmation'

const CampaignCreate = () => {
  const navigate = useNavigate()
  const {
    mills,
    participants,
    getUsersParticipant,
    detailCampaign,
    status,
    createCampaign,
    openModal,
    setOpenModal,
    handleOpenModal,
  } = useCampaign()

  const formik = useFormik({
    initialValues: detailCampaign,
    enableReinitialize: true,
    onSubmit: createCampaign,
  })

  const { values, errors, touched, setFieldValue, handleSubmit } = formik

  const checkDaily = () => {
    let disabled = false
    const participants = values.participantsExtend
    if (values.startTime == 0 || participants.length == 0) {
      disabled = true
    } else {
      participants.map(item => {
        if (item.targets[0].targetFfbWeightTonne == 0) {
          disabled = true
        }
      })
    }
    return disabled
  }

  useEffect(() => {
    values.partnerId !== '' && getUsersParticipant(values.partnerId)
  }, [values.partnerId])
  return (
    <div className="p-8 flex-col content-wrapper">
      <ModalCampaign
        isOpen={openModal}
        setModal={setOpenModal}
        isLoading={status == 'LOADING'}
        handleSubmit={handleSubmit}
      />
      <CampaignProgram
        isLoading={status == 'LOADING'}
        millData={mills}
        data={values}
        onChange={setFieldValue}
        errors={errors}
        touched={touched}
      />
      {values.startTime && values.endTime && values.partnerId ? (
        <CampaignParticipant
          detailCampaign={values}
          participants={participants}
          onChange={setFieldValue}
        />
      ) : (
        <></>
      )}

      <div className="flex gap-4 mt-5 justify-end">
        <ButtonLink
          data-testid="button-undo"
          variant="outline-primary"
          block
          label="Batalkan"
          className="py-4 px-6 text-sm w-[10%] h-[45px]"
          onClick={() => navigate('/campaign')}
        />
        <ButtonLink
          data-testid="button-add"
          variant="solid-primary"
          block
          label="Simpan"
          disabled={checkDaily() || !regexAlpha.test(values.name)}
          className="py-4 px-6 text-sm w-[10%] h-[45px]"
          onClick={handleOpenModal}
        />
      </div>
    </div>
  )
}

export default CampaignCreate
